import { matomoInstance } from '../components/MatomoProvider';

/**
 * Utility functions for tracking custom events with Matomo
 * These functions can be imported and used in any component
 */

/**
 * Track a custom event
 * @param {string} category - Event category (e.g., 'User Interaction')
 * @param {string} action - Event action (e.g., 'Button Click')
 * @param {string} [name] - Optional event name for additional details
 * @param {number} [value] - Optional numerical value associated with the event
 */
export const trackEvent = (category, action, name, value) => {
  matomoInstance.trackEvent({
    category,
    action,
    name,
    value
  });
};

/**
 * Track an outbound link click
 * @param {string} url - The URL that was clicked
 */
export const trackLink = (url) => {
  matomoInstance.trackLink({
    href: url
  });
};

/**
 * Track a site search
 * @param {string} keyword - The search keyword
 * @param {string} [category] - Optional search category
 * @param {number} [resultsCount] - Optional number of search results
 */
export const trackSiteSearch = (keyword, category, resultsCount) => {
  matomoInstance.trackSiteSearch({
    keyword,
    category,
    count: resultsCount
  });
};

/**
 * Track a goal conversion
 * @param {number} goalId - The ID of the goal in Matomo
 * @param {number} [value] - Optional conversion value
 */
export const trackGoal = (goalId, value) => {
  matomoInstance.trackGoal({
    goalId,
    value
  });
};

/**
 * Track a content impression
 * @param {string} name - Content name
 * @param {string} piece - Content piece
 * @param {string} target - Content target (e.g., URL)
 */
export const trackContentImpression = (name, piece, target) => {
  matomoInstance.trackContentImpression({
    name,
    piece,
    target
  });
};

/**
 * Track a content interaction
 * @param {string} name - Content name
 * @param {string} piece - Content piece
 * @param {string} target - Content target (e.g., URL)
 * @param {string} interaction - Interaction type (e.g., 'click')
 */
export const trackContentInteraction = (name, piece, target, interaction) => {
  matomoInstance.trackContentInteraction({
    name,
    piece,
    target,
    interaction
  });
};